import { Component, Input, OnInit } from '@angular/core';

import { SummaryBox } from '../../../models/summary-box.model';

@Component({
  selector: 'eiq-grid-summary-boxes',
  templateUrl: 'grid-summary-boxes.component.html',
  styleUrls: ['grid-summary-boxes.component.scss', '_grid-summary-boxes-theme.component.scss']
})
export class GridSummaryBoxesComponent implements OnInit {
  @Input() summaryBoxes: SummaryBox[];

  constructor() {}

  ngOnInit() {}
}
